const root = 'app';

const getAppIdFromUrl = (location) => {
  return location.pathname.split('/')[2];
}

const getTargetRestaurantIdFromUrl = (location) => {
  return location.pathname.split('/')[5];
}


const order = (appId) => {
  return `/${root}/${appId}/order`;
};

const orderFullPath = ({ appId, restaurantId, orderType, orderDate }) => {
  return `${order(appId)}/${orderType}/${restaurantId}/${orderDate}`;
}

const orderTakeAway = (appId) => {
  return `${order(appId)}/takeAway`;
};

const orderTakeAwayRestaurant = (appId, restaurantId) => {
  return `${orderTakeAway(appId)}/${restaurantId}`;
};

const orderMenu = (params) => {
  return `${orderFullPath(params)}/menu`;
};

const orderCart = (params) => {
  return `${orderFullPath(params)}/cart`;
};

const orderUserVoucher = (params) => {
  return `${orderFullPath(params)}/voucher`;
};

const orderDelivery = (appId) => {
  return `${order(appId)}/delivery`;
};

const orderDeliveryAddress = (appId) => {
  return `${order(appId)}/delivery/address`;
};

const orderDeliveryRestaurant = (appId, restaurantId) => {
  return `${orderDelivery(appId)}/${restaurantId}`;
};

const orderDeliveryRestaurantFromRoute = (route, restaurantId) => {
  const last = route.length - 1;
  const sanitized = (route[last] === '/') ? route.substring(0, last) : route;
  // if the previuos route was /address, we should remove the last
  // component before redirect to date-select-time container
  const nextRoute = sanitized.split('/').filter(comp => comp !== 'address').join('/');
  return `${nextRoute}/${restaurantId}`;
};

const orderCheckout = (params) => {
  return `${orderFullPath(params)}/checkout`;
};

const orderPayment = (params) => {
  return `${orderFullPath(params)}/payment`;
};

const orderEnd = (params) => {
  return `${orderFullPath(params)}/end`;
};

const orderEndFromRoute = (route) => {
  const last = route.lastIndexOf('/');
  const next = route.substring(0, last);
  return `${next}/end`;
};

const orderNoDelivery = (appId, offline = false) => {
  const base = `${order(appId)}/no-delivery`;
  if (offline) return `${base}?offline=true`;
  return base;
};

const booking = (appId) => {
  return `/${root}/${appId}/booking`;
};

const bookingDate = (appId, restaurant, date) => {
  return `/${root}/${appId}/booking/${restaurant}/${date}`;
};

const bookingCheckout = (appId, restaurant, date, slot, seats) => {
  return `/${root}/${appId}/booking/${restaurant}/${date}/${slot}/${seats}/checkout`;
};

const bookingEnd = (appId, restaurant, date, slot, seats) => {
  return `/${root}/${appId}/booking/${restaurant}/${date}/${slot}/${seats}/end`;
};

const bookingEndFromRoute = (route) => {
  const last = route.lastIndexOf('/');
  const next = route.substring(0, last);
  return `${next}/end`;
};


export default {
  order,
  orderTakeAway,
  orderTakeAwayRestaurant,
  orderDelivery,
  orderDeliveryAddress,
  orderDeliveryRestaurant,
  orderDeliveryRestaurantFromRoute,
  orderMenu,
  orderCart,
  orderUserVoucher,
  orderCheckout,
  orderPayment,
  orderEnd,
  orderEndFromRoute,
  orderNoDelivery,
  getAppIdFromUrl,
  getTargetRestaurantIdFromUrl,
  booking,
  bookingDate,
  bookingCheckout,
  bookingEnd,
  bookingEndFromRoute,
};



// WEBPACK FOOTER //
// ./src/lib/url.js